import {Environment} from '@eitje/api'
import {useMemo} from 'react'

export const useAddOrganisationEnvironments = invoices => {
	const environments = Environment.useDoIndex()

	const items = useMemo(() => {
		return invoices.map(invoice => ({
			...invoice,
			organisationEnvironments: _.filter(environments, environment => _.includes(invoice.organisation.environment_ids, environment.id)),
		}))
	}, [invoices])

	return items
}
